import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  text: '"El Tomo 4 — El Padre y el Permiso de Brillar — me sacudió. En dos días entendí por qué nunca me animé a cobrar lo que valía mi trabajo. Era una lealtad invisible con mi papá. Cuando lo vi, algo se soltó."'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  text: '"El Guión de Límites Elegantes fue lo que me faltaba. Tenía claro lo que sentía. No tenía las palabras. Ahora las tengo. Y las uso."'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  text: '"El Planner 21 Días fue lo que me mantuvo constante. Sin eso creo que hubiera entendido todo y no hubiera cambiado nada. La diferencia está en la práctica diaria."'
}, {
  initials: 'JM',
  name: 'Julia M.',
  location: 'Rosario',
  text: '"El Manual Anti-Culpa me lo releo cada vez que mi mamá llama. En serio. Lo tengo guardado en favoritos en el teléfono. Es mi ancla."'
}];
export function MoreTestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-198">
      <div className="container mx-auto max-w-5xl" data-id="element-199">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-200">
          <h2 className="text-2xl md:text-4xl font-bold text-[#F5ECD7] mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-201">
            ❤️ MÁS MUJERES QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-202">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-[#2D1B1B] border border-[#C9A96E]/20 rounded-2xl p-6 flex flex-col shadow-lg" data-id="element-203">
              <div className="flex items-center gap-3 mb-4" data-id="element-204">
                <div className="w-10 h-10 rounded-full bg-[#C9A96E]/20 border border-[#C9A96E]/30 flex items-center justify-center text-[#C9A96E] font-bold text-sm" data-id="element-205">
                  {t.initials}
                </div>
                <div data-id="element-206">
                  <div className="flex text-[#C9A96E] text-sm mb-0.5" data-id="element-207">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-[#F5ECD7] font-bold text-sm" data-id="element-208">
                    {t.name}{' '}
                    <span className="text-[#D4A5A5] font-normal" data-id="element-209">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-[#FAF3E8] text-sm leading-relaxed italic" data-id="element-210">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}